const SIGN = '32fc4550367e7e672c51146dfa95aff5'//'13257f692165d55b1e75f53489369a58' // 全局默认mall_id 
//const REQUEST_API = 'https://api.xuan-wing.com' //'http://api.new-xuan-erp.com'// 全局域名
const REQUEST_API = 'https://api.test.xuan-wing.com' //'http://api.new-xuan-erp.com'// 全局域名
const API_VERSION = 'v1' // 接口版本号
const STATIC_DOMAIN = 'https://static.xuan-wing.com/static'//'https://static.qijianshigw.com/static/' // 静态资源路径
// 插件数组
const addonsList = ['coupon']
const env = {
	SIGN,
	STATIC_DOMAIN,
	api_root: join(REQUEST_API, "/"),
	weixinOriginalId: 'gh_7c9b956798ee', //微信小程序的原始id，app分享到微信需要这个，打包不同的APP的话 换这个就可以了
	domain: REQUEST_API,
	addonsList
}


function join(...args) {
	return args.reduce((prev, next) => {
		return prev + next
	})
}


if (process.env.NODE_ENV === "development") {
	env.api_root = '/api/'
}

module.exports = env
